export default __webpack_public_path__ + "/dist/images/6805886.bc252147cfd2459a45cfb5f0f8ab2191.png";